module.exports = __webpack_public_path__ + "img/Seychelles.202f2e31.png";